/* eslint-disable import/no-extraneous-dependencies */
import Vue from "vue";
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
